import { useState, useEffect, useRef } from "react";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { useSelector } from "react-redux";
import React from "react";
import Loader from "../../shared/Loader/Loader";
import Notes from "../../shared/NotesTab/Notes";
import { enumUtil } from "../../../utils/Enum";


// ... existing code ...

const PatientAttendanceNotes = (props) => {
    const { BillingDocumentTypeID, row, isNotes, onClose } = { ...props };
    console.log(isNotes,'isNotes');
    

    let PateintIDR = useSelector((state) => state.Open_Patient_Tab.find((pt) => pt.active === true));
    PateintIDR = PateintIDR?.data?.id;
    let nameIDR = useSelector(state => state[`Open_Patient_Tab`].find((pt) => pt.active === true));
    nameIDR = nameIDR?.data?.id
    let File_Modal = {
        NoteFile: [],
        NoteReplyFile: [],
    };

    const [expanded, setExpanded] = useState('summarypt');
    const [activeNotes, setActiveNotes] = useState(isNotes);
    const [isLoading, setIsLoading] = useState(false);
    const [notesData, setNotesData] = useState([]);
    const [del, setDel] = useState(false);
    const [selectedFiles, setSelectedFiles] = useState(File_Modal);
    const [isAccending, setIsAccending] = useState('');
    const [Name, setName] = useState('');
    useEffect(() => { }, [row]);
    const sortedAscending = (e) => {
        e.stopPropagation();
        setIsAccending('Acc');
        let data = [...notesData];
        data.sort((a, b) => new Date(a.EnteredDate) - new Date(b.EnteredDate));
        setNotesData(data);
    };
    const sortedDescending = (e) => {
        e.stopPropagation();
        setIsAccending('Des');
        let data = [...notesData];
        data.sort((a, b) => new Date(b.EnteredDate) - new Date(a.EnteredDate));
        setNotesData(data);
    };
    const handleChangeAccodian = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    // Update the width when the component mounts or whenever Name changes
    let ReplyerRef = useRef(null);
    const [ReplyerWidth, setReplyerWidth] = useState(0);

    useEffect(() => {
        setReplyerWidth(ReplyerRef.current?.clientWidth);
    }, [Name]);

    useEffect(() => {
        setActiveNotes(isNotes)
    }, [isNotes])

    return (
        <>
            {isLoading ? <Loader /> : null}
            {/* {DeleteConfirmations} */}
            <div className={`claims-TabHeader__notes ${activeNotes && 'active__notes'}`}>
                <div className="claims-TabHeader__notes__CloseBtn" onClick={() => onClose() }>
                    <i className="icon-right-direction"></i>
                </div>
                {/* Notes */}
                <Accordion defaultExpanded onChange={handleChangeAccodian('notespt')}>
                    <AccordionSummary id="prac1-header" aria-controls="prac1-content" expandIcon={false}>
                        <div className="d-flex justify-content-lg-between w-100">
                            <p className="heading">Notes {row && row?.FileName} </p>
                            <div>
                                <i className={isAccending === 'Des' ? 'icon-Arrow-13' : 'icon-Arrow-13 light'} onClick={sortedDescending}></i>
                                <i className={isAccending === 'Acc' ? 'icon-Arrow-13 up dark' : 'icon-Arrow-13 up'} onClick={sortedAscending}></i>
                            </div>
                        </div>
                    </AccordionSummary>
                    <AccordionDetails>
                        {isLoading ? <Loader /> : null}

                        <Notes nameIDR={BillingDocumentTypeID} activeNotes={activeNotes} API_URL={enumUtil.controller.Patient} TableName={enumUtil.enumAPITableName.PatientNotes} ID={'PatientNotesID'} type={'Patient'} />

                    </AccordionDetails>
                </Accordion>
            </div>
        </>
    );
};

export default PatientAttendanceNotes;